const MINUTE = 60 * 1000;

/**
 * React Query cache presets for New Purchase Order hooks.
 * Spread into `useQuery` / `useInfiniteQuery` options: `{ ...poQueryCache.productPicker }`
 */
export const poQueryCache = {
  /** Vendor dropdown — stable; shared across listing + create. */
  vendorList: {
    staleTime: 5 * MINUTE,
    gcTime: 10 * MINUTE,
  },
  /** Product picker modal — shorter TTL; cost/qty can change mid-session. */
  productPicker: {
    staleTime: 2 * MINUTE,
    gcTime: 5 * MINUTE,
  },
  /** KPI cards + quick-filter chip counts — invalidated on PO writes only. */
  count: {
    staleTime: 5 * MINUTE,
    gcTime: 10 * MINUTE,
  },
  /** PO detail, generated PO number — always refetch when the hook mounts. */
  live: {
    staleTime: 0,
    gcTime: 5 * MINUTE,
    refetchOnMount: "always",
  },
};
